// 订单管理
import { ServerDistApi } from '@/group-cloud/network/ServerBizApi';

export class OrderApi {

    constructor() {
    }
    protected static groupUrl = '/ordering/man/order';
    // protected static groupNewUrl = '/ordering/man/order';
    protected static groupNewUrl = '/ordering/man/new/order';

    //订单来源
    public static async getOrderSource(data) {
        let uri = '/common/client/config/orderSource';
        return await ServerDistApi.get(uri, data);
    }
    //订单导出
    public static async orderdaochu(data) {
        let uri = '/ordering/export/newOrderDownload';
        return await ServerDistApi.send(uri, data);
    }
    //商品上架导出
    public static async goodsOnShelfExport(data) {
        let uri = '/sku/sell/config/loadSkuSellConfigDataExport';
        return await ServerDistApi.send(uri, data);
    }
    //出库单导出
    public static async deliveryExport(data) {
        let uri = '/ordering/manage/out/order/export';
        return await ServerDistApi.send(uri, data);
    }
    //分开商品上架导出
    public static async goodsSplitOnShelfExport(data) {
        let uri = '/sku/sell/config/exportDispersionSkuConfig';
        return await ServerDistApi.send(uri, data);
    }
    //发货单单导出
    public static async orderdaofah(data) {
        let uri = '/ordering/export/order';
        return await ServerDistApi.send(uri, data);
    }
    //订货单获取商品信息
    public static async Purchaseorder(data) {
        let uri = '/ordering/manage/order/detail';
        return await ServerDistApi.send(uri, data);
    }
    //出库单获取商品信息
    public static async Purchagetout(data) {
        let uri = '/ordering/manage/out/order/detail';
        return await ServerDistApi.send(uri, data);
    }
    //发货单获取商品信息
    public static async Commodityinformation(data) {
        let uri = '/ordering/manage/send/order/detail';
        return await ServerDistApi.send(uri, data);
    }
    //校验支付单号是否重复
    public static async check(data) {
        let uri = '/ordering/manage/order/pay/check';
        return await ServerDistApi.send(uri, data);
    }
    //审核确认
    public static async Auditconfirmation(data) {
        let uri = '/ordering/manage/order/update ';
        return await ServerDistApi.send(uri, data);
    }

    //支付方式
    public static async getPaySource(data) {
        let uri = '/common/client/config/paysource';
        return await ServerDistApi.get(uri, data);
    }

    //物流公司
    public static async getAllExpress(data) {
        let uri = '/tms/express/getAllExpress';
        return await ServerDistApi.get(uri, data);
    }

    //订货单手动下单
    public static async Ordermanually(data) {
        let uri = this.groupNewUrl + '/new';
        return await ServerDistApi.send(uri, data);
    }

    //渠道列表
    public static async ChannelList(data) {
        let uri = '/common/client/config/source_channel';
        return await ServerDistApi.get(uri, data);
    }

    //支付方式列表
    public static async PaysList(data) {
        let uri = '/common/client/config/paysource';
        return await ServerDistApi.get(uri, data);
    }

    //添加支付方式
    public static async AddPayType(data) {
        let uri = this.groupUrl + '/addPay';
        return await ServerDistApi.send(uri, data);
    }

    //发货单订单状态枚举
    public static async NewStateList(data) {
        let uri = '/common/client/config/new_order_status';
        return await ServerDistApi.get(uri, data);
    }

    //发货单订单状态枚举
    public static async StateList(data) {
        let uri = '/common/client/config/order_status';
        return await ServerDistApi.get(uri, data);
    }

    //异常标注类型
    public static async AbnormalList(data) {
        let uri = '/common/client/config/abnormal';
        return await ServerDistApi.get(uri, data);
    }

    //订货单查询
    public static async OrderformList(data) {
        // let uri = this.groupNewUrl + '/list';
        let uri = '/ordering/manage/order/list';
        return await ServerDistApi.send(uri, data);
    }

    //发货单查询
    public static async OrderInvoList(data) {
        // let uri = this.groupUrl + '/list';
        let uri = '/ordering/manage/send/order/list'
        return await ServerDistApi.send(uri, data);
    }

    //出库单查询
    public static async OrderWareList(data) {
        let uri = '/ordering/manage/out/order/list'
        return await ServerDistApi.send(uri, data);
    }

    //出库单商品信息列表查询
    public static async getGoodsList(data) {
        let uri = '/ordering/outBillDetail/skuList'
        return await ServerDistApi.get(uri, data);
    }

    //出库单商品信息列表查询
    public static async sendGoodsList(data) {
        let uri = '/ordering/outBillDetail/skuList'
        return await ServerDistApi.send(uri, data);
    }

    //出库单商品信息列表查询
    public static async getGoodsInfo(data) {
        let uri = '/ordering/outBill/topInfo'
        return await ServerDistApi.get(uri, data);
    }

    //订货单添加商品
    public static async OrderAddstore(data) {
        let uri = this.groupUrl + '/itemAdd';
        return await ServerDistApi.send(uri, data);
    }

    //取消订单
    public static async cancelOrder(data) {
        let uri = this.groupUrl + '/cancel';
        return await ServerDistApi.send(uri, data);
    }
    // 订货单多选取消订单
    public static async cancelNewOrderChoice(data) {
        let uri = this.groupNewUrl + '/cancel/batch';
        return await ServerDistApi.send(uri, data);
    }
     // 多选取消订单
    public static async cancelOrderChoice(data) {
        let uri = this.groupUrl + '/cancel/batch';
        return await ServerDistApi.send(uri, data);
    }

    // 订单审核确认
    public static async confirmOrder(data) {
        let uri = this.groupUrl + '/review';
        return await ServerDistApi.send(uri, data);
    }

    //发货单取消审核
    public static async onfirmOrderReview(data) {
        let uri = this.groupUrl + '/review/back';
        return await ServerDistApi.send(uri, data);
    }

    //发货单sku拆单验证
    public static async splitOrderBySkuCheck(data) {
        let uri = this.groupUrl + '/splitOrderBySkuCheck';
        return await ServerDistApi.send(uri, data);
    }

    //发货单添加商品拆单
    public static async splitOrderBySkuAddSkuList(data) {
        let uri = this.groupUrl + '/splitOrderBySkuAddSkuList';
        return await ServerDistApi.send(uri, data);
    }

    //多选订单审核确认
    public static async confirmOrderChoice(data) {
        let uri = this.groupUrl + '/review/batch';
        return await ServerDistApi.send(uri, data);
    }

    // 订单添加支付
    public static async OrderAddPay(data) {
        let uri = this.groupUrl + '/pay';
        return await ServerDistApi.send(uri, data);
    }

    // 订单标注异常
    public static async OrderAbnormal(data) {
        let uri = this.groupUrl + '/abnormal';
        return await ServerDistApi.send(uri, data);
    }

    // 多选订单标注异常
    public static async OrderAbnormalChoice(data) {
        let uri = this.groupUrl + '/abnormal/batch';
        return await ServerDistApi.send(uri, data);
    }

    // 发货单转正常
    public static async OrderTonormal(data) {
        let uri = this.groupUrl + '/tonormal/batch';
        return await ServerDistApi.send(uri, data);
    }

    // 发货单详情转正常
    public static async OrderDetailTonormal(data) {
        let uri = this.groupUrl + '/tonormalAndSave';
        return await ServerDistApi.send(uri, data);
    }

    // 发货单详情异常保存
    public static async OrderDetailSave(data) {
        let uri = this.groupUrl + '/saveAll';
        return await ServerDistApi.send(uri, data);
    }

    // 订货单去添加商品
    public static async GoaddStoreList(data) {
        let uri = this.groupUrl + '/toItemAdd';
        return await ServerDistApi.send(uri, data);
    }

    //修改卖家备注
    public static async updateOrderInfo(data) {
        let uri = this.groupUrl + '/update';
        return await ServerDistApi.send(uri, data);
    }

    //查询订货单关联的商品
    public static async getNewOrderGoods(data) {
        let uri = this.groupNewUrl + '/info';
        return await ServerDistApi.send(uri, data);
    }

    //查询发货单关联的商品
    public static async getOrderGoods(data) {
        let uri = this.groupUrl + '/info';
        return await ServerDistApi.send(uri, data);
    }

    //新查询详情接口
    public static async getOrderGoods1(data) {
        let uri = '/ordering/client/order/info1';
        return await ServerDistApi.send(uri, data);
    }

    //查询订单渠道
    public static async getOrderChannel(data) {
        let uri = '/common/client/config/source_channel';
        return await ServerDistApi.get(uri, data);
    }

    //查询买家类型
    public static async getBuyertype(data) {
        let uri = '/ordering/man/customertype/list';
        return await ServerDistApi.send(uri, data);
    }

    // //查询买家类型
    // public static async getBuyerType(data) {
    //     let uri = '/customer/man/search/client';
    //     return await ServerDistApi.send(uri, data);
    // }
    //查询买家名称
    public static async getBuyerName(data) {
        let uri = '/customer/man/searchUser';
        return await ServerDistApi.send(uri, data);
    }

    //创建新订单
    public static async createNewOrder(data) {
        let uri = this.groupNewUrl + '/new';
        return await ServerDistApi.send(uri, data);
    }

    //获取订单的物流跟踪信息
    public static async getOrderFollowInfo(data) {
        let uri = '/tms/express/trace/order';
        return await ServerDistApi.get(uri, data);
    }

    //取消支付
    public static async delAddPayType(data) {
        let uri = this.groupUrl + '/delPay';
        return await ServerDistApi.send(uri, data);
    }

    //修改商品数量和成交价格
    public static async updateGoodsInfo(data) {
        let uri = this.groupUrl + '/items/update';
        return await ServerDistApi.send(uri, data);
    }

    //获取操作日志
    public static async getOptLogList(data) {
        let uri = '/ordering/log/query/preview';
        return await ServerDistApi.get(uri, data);
    }


    // 订货单审核
    public static async reviewDetails(data) {
		let uri = this.groupNewUrl + '/reviewDetails';
		return await ServerDistApi.send(uri, data);
    }

    // 发货单审核
    public static async reviewDetail(data) {
        let uri = this.groupUrl + '/reviewDetail';
        return await ServerDistApi.send(uri, data);
    }

    // 订货单确认审核
    public static async batchReviews(data) {
		let uri = this.groupNewUrl + '/batchReview';
		return await ServerDistApi.send(uri, data);
    }

    // 发货单确认审核
    public static async batchReview(data) {
        let uri = this.groupUrl + '/batchReview';
        return await ServerDistApi.send(uri, data);
    }

    // 库存查询
    public static async skuSendStocks(data) {
        let uri = this.groupUrl + '/skuSendStocks';
        return await ServerDistApi.send(uri, data);
    }
    // 库存查询
    public static async skuStocks(data) {
        let uri = this.groupUrl + '/skuStocks';
        return await ServerDistApi.send(uri, data);
    }

    // 获取发货数据
    public static async queryDeliveryOrder(data) {
        let uri = '/tms/queryDeliveryOrder';
        return await ServerDistApi.send(uri, data);
    }
    // 确认推单
    public static async batchOrderSend(data) {
        let uri = '/tms/batchOrderSend';
        return await ServerDistApi.send(uri, data);
    }

    //查看商品在各个仓库存
    public static async getSkuStock(data) {
        let uri = '/stock/skuStocksInfo';
        return await ServerDistApi.get(uri, data);
    }

    //拆分订单
	public static async splitOrder(data) {
		let uri =  this.groupUrl +'/batchSplit';
		return await ServerDistApi.send(uri, data);
	}
    //拆分订单列表
    public static async getBatchOrderSplit(data) {
        let uri = this.groupUrl + '/batchOrderSplit';
        return await ServerDistApi.send(uri, data);
    }

    //批量换商品
    public static async exchangeGood(data) {
        let uri = '/ordering/man/bulk/exchange';
        return await ServerDistApi.send(uri, data);
    }
    //客户类型tab header
	public static async getTabsList(data) {
		let uri = this.groupUrl +'/type';
		return await ServerDistApi.get(uri, data);
	}

    //查询可合并的订单
    public static async canCombineOrder(data) {
            let uri = this.groupUrl + '/canCombine';
            return await ServerDistApi.send(uri, data);
        }
    //合并订单操作
    public static async combineOrder(data) {
            let uri = this.groupUrl + '/combine';
            return await ServerDistApi.send(uri, data);
        }

    //锁定订单
    public static async lockOrder(data) {
        let uri = this.groupUrl + '/lock';
        return await ServerDistApi.send(uri, data);
    }

    //取消锁定订单
    public static async cancelLockOrder(data) {
        let uri = this.groupUrl + '/unLock';
        return await ServerDistApi.send(uri, data);
    }

    //发货单确认出库
    public static async confirmDeliOrder(data) {
        let uri = this.groupUrl + '/logisticsNumber';
        return await ServerDistApi.send(uri, data);
    }

    // 发货单分配发货仓跳转
    public static async setOrderWsIdQuery(data) {
        let uri = this.groupUrl + '/setOrderWsIdQuery';
        return await ServerDistApi.send(uri, data);
    }

    // 发货单分配发货仓保存
    public static async setOrderWsId(data) {
        let uri = this.groupUrl + '/setOrderWsId';
        return await ServerDistApi.send(uri, data);
    }

    // 发货单根据sku拆分订单筛选订单
    public static async getSplitOrderBill(data) {
        let uri = this.groupUrl + '/splitOrderBySkuSelectOrderBill';
        return await ServerDistApi.send(uri, data);
    }

    // 发货单校验要拆分的订单
    public static async splitOrderBySku(data) {
        let uri = this.groupUrl + '/splitOrderBySku';
        return await ServerDistApi.send(uri, data);
    }

    //订货单客户编码查询
    public static async getClientInfoList(data) {
        let uri = '/yoozClient/getClientInfoList';
        return await ServerDistApi.send(uri, data);
    }

    //订货单门店编码查询
    public static async getStoreInfoList(data) {
        let uri = '/yoozStore/getStoreInfoList';
        return await ServerDistApi.send(uri, data);
    }
    //订货单门店编码查询
    public static async getInfoList(data) {
        let uri = '/yoozStore/getInfoList';
        return await ServerDistApi.send(uri, data);
    }

    //订单详情换货
    public static async changeSkuGoods(data) {
        let uri = this.groupUrl + '/changeSku';
        return await ServerDistApi.send(uri, data);
    }
}
